import { useQuery } from 'react-query';
import {
  getGlobalConfig,
  getLanguageToUse,
} from 'services/globalConfig.services';
import type { GlobalConfig } from 'interfaces/GlobalConfig.interface';

interface UseGlobalConfigProps {
  cmsSlug: string;
}

interface UseGlobalConfigReturn {
  data: GlobalConfig;
  error: unknown;
  isLoading: boolean;
}

export const useGlobalConfig = ({
  cmsSlug,
}: UseGlobalConfigProps): UseGlobalConfigReturn => {
  // Fetch and transform config data using select
  const {
    data: globalConfig,
    error,
    isLoading,
  } = useQuery<GlobalConfig>(
    ['pp-global-config', cmsSlug],
    () => getGlobalConfig(cmsSlug),
    {
      enabled: !!cmsSlug,
      select: (config) => {
        // Transform language inline during data selection
        const langToUse = getLanguageToUse(config);
        if (langToUse !== config.config.language) {
          return {
            ...config,
            config: { ...config.config, language: langToUse },
          };
        }
        return config;
      },
    },
  );

  return {
    data: globalConfig,
    error,
    isLoading,
  };
};
